function game_104()
{

}

game_104.odd_map  = {
  "9":[0,0,100,350,800],
  "8":[0,0,50,100,500],
  "7":[0,0,10,50,350],
  "6":[0,0,10,40,200],
  "5":[0,0,5,25,120],
  "4":[0,0,5,20,100],
  "3":[0,0,5,15,80],
  "2":[0,0,5,15,60],
  "1":[0,0,5,10,50],
};

export {
  game_104
};



// WEBPACK FOOTER //
// ./src/components/slots/game_104.js